export interface WordPart {
  text: string
  /** Слово есть в списке общих слов пары — показывается жирным. */
  shared: boolean
}

const WORD = /[\p{L}\p{N}]+/gu

/**
 * Наименование по частям: общие слова пары отмечены, остальной текст (пробелы, знаки, числа с единицами) идёт как есть и
 * дословно (ADR-8). Слова сравниваются без учёта регистра.
 */
export function splitByWords(name: string, shared: readonly string[]): WordPart[] {
  if (shared.length === 0) return [{ text: name, shared: false }]
  const wanted = new Set(shared.map((word) => word.toLowerCase()))
  const parts: WordPart[] = []
  let cursor = 0
  for (const match of name.matchAll(WORD)) {
    const index = match.index
    if (index > cursor) parts.push({ text: name.slice(cursor, index), shared: false })
    parts.push({ text: match[0], shared: wanted.has(match[0].toLowerCase()) })
    cursor = index + match[0].length
  }
  if (cursor < name.length) parts.push({ text: name.slice(cursor), shared: false })
  return parts
}
